<!--  -->
<template>
<div class=''>
    <el-upload
    :auto-upload="true"
    :show-file-list="false"
    :http-request="customRequest"
    :before-upload="upload"
    class="avatar-uploader">
    <img v-if="imgUrl" :src="imgUrl">
    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
  </el-upload>
  <el-dialog :visible.sync="dialogVisible" append-to-body>
    <img width="100%" :src="dialogImageUrl" alt="">
  </el-dialog>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {applicationName} from '@/utils/const.js'
import service from '@/utils/request'
export default {
  name:"sUploadImg",
//import引入的组件需要注入到对象中才能使用
components: {},
props:{
  getImageUrl:{
    type:Function
  },
  url:{
    type:String
  }
},
data() {
//这里存放数据
return {
  dialogImageUrl: '',
  dialogVisible: false,
  imgUrl:null,
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {
  url(val){
    if(val!=""&&val!=null&&val!=undefined){
     this.imgUrl = val
    }else{
      this.imgUrl=null
    }
  }
},
//方法集合
methods: {

      customRequest(options){
        const formData = new FormData()
        formData.append('file', options.file)
        // 使用相对路径 + 覆盖 baseURL，让请求走当前域名 nginx 反代
        // 避免生产 build 时 VUE_APP_API_URL 指向其他域名导致 CORS
        const url = `${process.env.VUE_APP_API_URL+applicationName}/admin/file/upload/avatars`
        service.post(url, formData, { baseURL: '' }).then((res)=>{
          // res 是 request.js 拦截器返回的 response.data，格式为 {code:200, data:"图片url"}
          console.log('upload response:', res)
          const imgUrl = (res && res.data) ? res.data : res
          this.imgUrl = `${imgUrl}`
          this.getImageUrl(`${imgUrl}`)
        }).catch((err)=>{
          console.error('upload error:', err)
          let msg = '图片上传失败'
          try {
            if (err && err.message) msg += ': ' + err.message
            else if (typeof err === 'string') msg += ': ' + err
          } catch(e) {
            // 字符串拼接安全操作，忽略异常
          }
          this.$message.error(msg)
        })
      },
          
      upload(file) {
        const isjpg = file.type === 'image/jpg';
				const isjpeg = file.type === 'image/jpeg';
				const isgif = file.type === 'image/gif';
				const ispng = file.type === 'image/png';
				const isJPG = file.type === 'image/JPG';
				const isJPEG = file.type === 'image/JPEG';
				const isGIF = file.type === 'image/GIF';
				const isPNG = file.type === 'image/PNG';
				if (!(isJPG || isJPEG || isGIF || isPNG || isjpg || isjpeg || isgif || ispng)) {
					this.$message.error('只能上传JPG 、JPEG 、GIF、 PNG格式的图片!');
          return false;
				}
			
				const isLt2M = file.size / 1024 / 1024 <= 15;
				if (!isLt2M) {
					this.$message.error('上传单张图片大小不能超过15MB!');
				}
				return isLt2M;
      },
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss'>
.avatar-uploader .avatar-uploader-icon {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
.avatar-uploader .avatar-uploader-icon:hover {
  border-color: #409EFF;
}
.avatar-uploader img {
  width: 178px;
  height: 178px;
  display: block;
}
/** scoped 表示 样式自在当前组件有效*/
//@import url(); 引入公共css类
</style>
